module.exports = __webpack_public_path__ + "media/little-racoon.1b2aa4d5.mp3";